"use client";

import * as React from "react";
import useEnhancedEffect from "@mui/utils/useEnhancedEffect";

// https://github.com/mui/material-ui/blob/master/packages/mui-base/src/NoSsr/NoSsr.tsx
// without prop-types
export function NoSsr(props) {
	const { children, defer = false, fallback = null } = props;
	const [mountedState, setMountedState] = React.useState(false);

	useEnhancedEffect(() => {
		if (!defer) {
			setMountedState(true);
		}
	}, [defer]);

	React.useEffect(() => {
		if (defer) {
			setMountedState(true);
		}
	}, [defer]);

	return <React.Fragment>{mountedState ? children : fallback}</React.Fragment>;
}
